import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   WikiLink,
   Blockquote,
   History,
   CustomMention,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   FeaturedQuote,
} from '../extensions';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { MenuSeparator } from '../components/MenuSeparator';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   BlockquoteButton,
   UndoButton,
   RedoButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const CommentsExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   WikiLink,
   Blockquote,
   History,
   CustomMention,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   FeaturedQuote,
];

export const CommentsMenuBar = () => (
   <TiptapMenubar>
      <BoldButton />
      <ItalicButton />
      <CodeButton />
      <LinkButton />
      <BlockquoteButton />
      <MenuSeparator />
      <UndoButton />
      <RedoButton />
   </TiptapMenubar>
);
